import omit from 'lodash.omit';
import { NextRouter, useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import React from 'react';
import { PAGE_MAX } from '../../components/designsystem/Pagination';
import SearchList from '../../components/SearchList';
import { searchViewParams } from '../../constants/searchParams';
import getLastMinuteOptions from '../../utils/getLastMinuteOptions';
import { brandConfig } from '../_app';
import Search from '../../components/Search';
import { GetStaticProps } from 'next';

export const getActionProps = (query: ParsedUrlQuery, router: NextRouter) => ({
    onMapClick: () => {
        router.push('/lastminute/map');
    },
    onListClick: () => {
        router.push('/lastminute');
    },
});

const Index = () => {
    const router = useRouter();
    const query: ParsedUrlQuery = omit(router.query, Object.keys(searchViewParams));

    return (
        <Search
            amountPerPage={PAGE_MAX}
            ResultsComponent={SearchList}
            contentWrapperVariant="searchList"
            buttonTypes={['filters', 'map', 'sort']}
            ignoreStorage
            defaultAccommodationType={brandConfig?.lastMinute?.defaultAccommodationType}
            {...getActionProps(query, router)}
            {...getLastMinuteOptions()}
        />
    );
};

export default Index;
export const getStaticProps: GetStaticProps = async () => ({
        props: {},
    });
